import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';
import actions from './actions';

import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

function* createBook() {
  yield takeEvery(actions.CREATE_BOOK, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_HOST}/api/book`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err, 'book');
    } finally {
      yield put({ type: actions.CREATE_BOOK_ENDED });
    }
  });
}

function* searchBooks() {
  yield takeEvery(actions.SEARCH_BOOKS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/book?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err, 'book');
    } finally {
      yield put({ type: actions.SEARCH_BOOKS_ENDED });
    }
  });
}

function* findBook() {
  yield takeEvery(actions.FIND_BOOK, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/book/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err, 'book');
    } finally {
      yield put({ type: actions.FIND_BOOK_ENDED });
    }
  });
}

function* updateBook() {
  yield takeEvery(actions.UPDATE_BOOK, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_HOST}/api/book`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err, 'book');
    } finally {
      yield put({ type: actions.UPDATE_BOOK_ENDED });
    }
  });
}

function* deleteBooks() {
  yield takeEvery(actions.DELETE_BOOKS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${API_HOST}/api/book`, { data });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err, 'book');
    } finally {
      yield put({ type: actions.DELETE_BOOKS_ENDED });
    }
  });
}

function* getMediaTypes() {
  yield takeEvery(actions.GET_MEDIA_TYPES, function* (action) {
    const { onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/book/mediaTypes`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err, 'book');
    } finally {
      yield put({ type: actions.GET_MEDIA_TYPES_ENDED });
    }
  });
}

function* archiveBooks() {
  yield takeEvery(actions.ARCHIVE_BOOKS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_HOST}/api/book/archiveBooks`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err, 'book');
    } finally {
      yield put({ type: actions.ARCHIVE_BOOKS_END });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createBook),
    fork(searchBooks),
    fork(findBook),
    fork(updateBook),
    fork(deleteBooks),
    fork(getMediaTypes),
    fork(archiveBooks),
  ]);
}
